import { render, staticRenderFns } from "./PatientMedicalReportPopup.vue?vue&type=template&id=5b8e321a"
import script from "./PatientMedicalReportPopup.vue?vue&type=script&lang=js"
export * from "./PatientMedicalReportPopup.vue?vue&type=script&lang=js"
import style0 from "./PatientMedicalReportPopup.vue?vue&type=style&index=0&id=5b8e321a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports